import React from 'react';
import styled from 'styled-components';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Avatar from '../../Account/Profile/Avatar';
import { colors } from '../../../constants/colors';
import { fontSize } from '../../../constants/text';
import AccountDrawer from './AccountDrawer';
import useOpenDrawer from '../hooks/useOpenDrawer';
import useClickProfileSelector from '../hooks/useClickProfileSelector';

const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const FirstName = styled.div`
  color: ${colors.squid};
  font-size: ${fontSize.small};
`;

const ExpandIcon = styled(ExpandMore)`
  color: ${colors.squid};
  margin-right: 4px;
`;

const StyledMenuIcon = styled.div`
  cursor: pointer;
`;

type OwnProps = {
  accountSummary?: any;
  currentProfile?: any;
  handleLogout?: (...args: any[]) => any;
  profileColor?: any;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof LoggedInMenu.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'LoggedInMenu' implicitly has type 'any' because i... Remove this comment to see the full error message
const LoggedInMenu = (props: Props) => {
  const { handleLogout, currentProfile, profileColor, accountSummary } = props;

  const { open, handleOpenDrawer, handleCloseDrawer } = useOpenDrawer();
  const onClickProfileSelector = useClickProfileSelector(accountSummary, handleOpenDrawer);

  return (
    <div>
      <StyledMenuIcon onClick={onClickProfileSelector}>
        <IconContainer>
          <FirstName>{currentProfile.first_name}</FirstName>

          <ExpandIcon fontSize="small" />

          <Avatar profileColor={profileColor.primary} userProfile={currentProfile} />
        </IconContainer>
      </StyledMenuIcon>

      <AccountDrawer
        onClose={handleCloseDrawer}
        currentProfile={currentProfile}
        handleLogout={handleLogout}
        accountSummary={accountSummary}
        open={open}
      />
    </div>
  );
};

LoggedInMenu.defaultProps = {
  accountSummary: { user_profiles: [] },
  currentProfile: {},
};

export default LoggedInMenu;
